import * as React from 'react';

import { AsideColumnLayout } from '../AsideColumnLayout/AsideColumnLayout';
import { AsideColumnLayoutSlot } from '../AsideColumnLayoutSlot/AsideColumnLayoutSlot';
import { ContactUsButton } from '../ContactUsButton/ContactUsButton';
import { SocialsNavigation } from '../SocialsNavigation/SocialsNavigation';
import { Navigation } from '../../../../components/Navigation/Navigation';

import * as cs from './Aside.module.css';

interface Props {
  forceUseTheme?: boolean;
  hideContactUs?: boolean;
}

export const Aside = ({ forceUseTheme, hideContactUs }: Props) => {
  return (
    <AsideColumnLayout>
      <AsideColumnLayoutSlot position="top">
        {!hideContactUs && (
          <div className={cs.contact}>
            <ContactUsButton />
          </div>
        )}
      </AsideColumnLayoutSlot>

      <AsideColumnLayoutSlot position="center" forceUseTheme={forceUseTheme}>
        <Navigation className={cs.socials} label="Socials">
          <SocialsNavigation />
        </Navigation>
      </AsideColumnLayoutSlot>
    </AsideColumnLayout>
  );
};
